<template>
  <div :style="{'overflow-x': overflow}">
    <transition :name="transitionName" @after-leave="enter" mode="out-in">
      <router-view :key="$route.params.id"/>
    </transition>
  </div>
</template>

<script>
  export default {
    name: 'listings',
    data() {
      return {
        transitionName: '',
        overflow: ''
      }
    },
    watch: {
      '$route' (to, from) {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'slide-fade-right':'slide-fade-left'
      }
    },
    created() {
      this.overflow = this.$route.name === 'listings' ? 'unset' : 'hidden'
    },
    methods: {
      enter() {
        this.overflow = this.$route.name === 'listings' ? 'unset' : 'hidden'
      }
    }
  }
</script>
